import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CruiseService } from '../services/cruise.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: []
})
export class SSOComponent implements OnInit {

  public queryData = {
    userlogin: '',
    dateupto: ''
  };

  public pipe: DatePipe = new DatePipe('en-US');
  private baseURL: any = ''; private merchantURL: any = '';
  private merchantsetup: any = {};
  private systemsetup: any = {};
  private queryStr: any = '';
  private useremail: any = ''; public otpCode: any = ''; private profileData: any = {};

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private loginService: CruiseService, private toastr: ToastrService, private route: ActivatedRoute, private router: Router, platformLocation: PlatformLocation) {
    this.route.queryParams.subscribe(
      data => {
        //console.log(data);
        this.queryData.userlogin = data.userlogin;
        this.queryData.dateupto = data.dateupto;
        this.queryStr = data.userlogin + "~" + data.dateupto;
      });

    if (isPlatformBrowser(this.platformId)) { sessionStorage.clear(); localStorage.clear(); }
    // var merchantdata = this.route.snapshot.data['merchantsetup'];
    // var staticdata = this.route.snapshot.data['staticdata'];
    // this.merchantsetup = JSON.parse(JSON.parse(JSON.parse(JSON.stringify(merchantdata.d))).merchantsetup)
    // this.systemsetup = JSON.parse(JSON.parse(JSON.stringify(staticdata.d)));
  }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) { sessionStorage.clear(); localStorage.clear(); }
    //let userlogin = this.loginService.getdecryptDataSSO(this.queryData.userlogin);
    this.loginService.getProfile(this.queryData.userlogin, this.queryData.dateupto).subscribe(data => {
      this.profileData = JSON.parse(JSON.stringify(data)).d;

      if (JSON.parse(this.profileData).status == "failed") {
        this.toastr.error("Either Login Credentials Wrong or Expired ! You are redirected to Main Page");
        setTimeout(() => {
          this.router.navigate([""]);
        }, 3000);
      } else {
        if (isPlatformBrowser(this.platformId)) {
          sessionStorage.setItem("logindata", JSON.stringify(this.profileData));
          sessionStorage.setItem("isAgentLoggedIn", "true");
          sessionStorage.setItem("loginType", "B2B");
        }
        this.router.navigate([""]);
      }
    }, error => console.log(error));

  }
}
